import styled from "styled-components";

interface PropsComps {
  bgColor?: string;
  textColor?: string;
}

export const Section = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  flex: 1;
  margin-bottom: 2px;
`;

interface MultipleProps {
  flex: number;
}

export const Flex = styled.div`
  flex: ${(props: MultipleProps) => props.flex};
  display: flex;
`;

export const FlexOption = styled.div`
  flex: ${(props: MultipleProps) => props.flex};
  display: flex;
  overflow: auto;
  padding-vertical: 10px;

  &::-webkit-scrollbar {
    height: 10px; /* Ancho del scroll */
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #d0d0d0;
    border-radius: 25px 25px;
  }
`;

export const SelectedOption = styled.div`
  margin: 5px 5px 5px 0px;
  border-radius: 25px;
  height: 18px;
  font-size: 10px;
  padding-left: 8px;
  width: max-content;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props: PropsComps) => props.bgColor || "#f2a48fcc"};
  color: ${(props: PropsComps) => props.textColor || "#2b2b2b"};
`;

export const Separator = styled.div`
  width: 100%;
  height: 13px;
  background-color: #9c9c9c;
  margin: 5px;
  border-radius: 25px;
  border-style: solid;
  border-width: 2px;
  border-color: #6c6c6c;
`;

export const SectionSelectedOptions = styled.div`
  width: 100%;
  height: 150px;
  background-color: white;
  margin: 5px;
  border-radius: 10px;
  border-style: solid;
  border-width: 2px;
  border-color: #9c9c9c;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 10px; /* Ancho del scroll */
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #d0d0d0;
    border-radius: 25px 25px;
  }
`;

export const Option = styled.option`
  height: 35px;
  background-color: ${(props: PropsComps) => props.bgColor || "#FBCDC4"};
  color: ${(props: PropsComps) => props.textColor || "#2b2b2b"};
  margin-top: 8px;
  display: flex;
  padding-left: 10px;
  width: 90%;
  font-size: 17px;
  align-items: center;
  align-self: center;
  cursor: pointer;

  &:hover {
    background-color: #696969;
    color: white;
  }
`;
